import { cloneDeep } from 'lodash';
import ChatbotActions from '../actions/ChatbotCRUDActions';
import Actions from '../actions/actions';
import { setBusy, setUnBusy, retrieved } from './common/commonReducers';
import { ChatbotState } from '../interfaces/chatbot';

const initialState: ChatbotState = {
  entities: [],
  busy: false,
  selectedEntity: null,
  languages: [],
  activeChatbot: null,
  basicListByCompany: [],
  errors: {
    templateCode: '',
  },
};

const attachToFacebookPage = (state: ChatbotState) => ({
  ...state,
  busy: false,
});

const retrievedBasicListAction = (
  state: ChatbotState,
  action,
): ChatbotState => {
  const { basicListByCompany } = action;

  return {
    ...state,
    busy: false,
    basicListByCompany,
  };
};

const updateChatbot = (state: ChatbotState, action): ChatbotState => {
  const { entity } = action;
  const newState = cloneDeep(state);
  const entityIndex = newState.entities.findIndex(e => e.id === entity.id);
  newState.entities[entityIndex] = entity;

  if (newState.activeChatbot && newState.activeChatbot.id === entity.id) {
    newState.activeChatbot = entity;
  }

  newState.busy = false;
  return newState;
};

const retreivedAllChatbots = (state: ChatbotState, action): ChatbotState => {
  // changed to cloneDeep, because we currently have data models with methods
  // and { ...state } cloning use shallow cloning, and missed methods
  const newState = cloneDeep(state);
  const { entities } = action;
  newState.busy = false;
  newState.entities = entities;
  const activeChatbot = state.activeChatbot;
  const newActiveChatbot =
    activeChatbot &&
    activeChatbot.id &&
    entities.find(e => e.id === activeChatbot.id);

  if (newActiveChatbot) {
    newState.activeChatbot = newActiveChatbot;
  }
  return newState;
};

const setFEActiveChatbot = (
  state: ChatbotState,
  action: { botId: number },
): ChatbotState => {
  const newState = cloneDeep(state);
  const { botId } = action;
  const newActiveChatbot = botId && newState.entities.find(e => e.id === botId);

  if (newActiveChatbot) {
    newState.activeChatbot = newActiveChatbot;
  }
  return newState;
};

const setErrors = (state: ChatbotState, action): ChatbotState => {
  const { errors: prevErrors } = state;
  const { errors: nextErrors } = action;

  const errors = {
    ...prevErrors,
    ...nextErrors,
  };

  return {
    ...state,
    errors,
    busy: false,
  };
};

export default function chatbot(state = initialState, action) {
  switch (action.type) {
    case ChatbotActions.retrievedBasicListAction:
      return retrievedBasicListAction(state, action);
    case ChatbotActions.busyAction:
      return setBusy(state);
    case ChatbotActions.polledAction: {
      const { entities } = state;
      if (entities.length) {
        return retrieved(state, action);
      }
      return {
        ...state,
        busy: false,
      };
    }
    case ChatbotActions.retrievedAction: {
      const { entities } = state;
      if (entities.length) {
        const updatedState = retrieved(state, action);

        return {
          ...updatedState,
          activeChatbot: action.entity,
        };
      }
      return {
        ...state,
        busy: false,
        activeChatbot: action.entity,
      };
    }
    case ChatbotActions.retrievedAllAction:
      return retreivedAllChatbots(state, action);
    case ChatbotActions.updateAction:
      return updateChatbot(state, action);
    case ChatbotActions.attachToFacebookPageAction:
      return attachToFacebookPage(state);
    case ChatbotActions.getLanguagesAction: {
      return {
        ...state,
        busy: false,
        languages: action.entity.languages,
      };
    }
    case ChatbotActions.resetChatbotsAction: {
      return {
        ...state,
        busy: false,
        entities: [],
        errors: {},
      };
    }
    case ChatbotActions.setFEActiveChatbotAction:
      return setFEActiveChatbot(state, action);
    case ChatbotActions.errorsAction:
      return setErrors(state, action);
    case ChatbotActions.resetErrorsAction: {
      return {
        ...state,
        errors: initialState.errors,
      };
    }
    case ChatbotActions.unbusyAction:
      return setUnBusy(state);
    case Actions.RESET:
      return initialState;
    case Actions.UNBUSY:
      return setUnBusy(state);
    default:
      return state;
  }
}
